// extracted by mini-css-extract-plugin
export var container = "styles-module--container--eb5a9";
export var input = "styles-module--input--d2618";
export var searchArea = "styles-module--searchArea--a96c6";